const pad = (value) => String(value).padStart(2, '0');

export const toDateInput = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const parseDateInput = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

const startOfISOWeek = (date) => {
  const result = new Date(date);
  const daysFromMonday = (result.getDay() + 6) % 7;
  result.setDate(result.getDate() - daysFromMonday);
  return result;
};

const isoWeekValue = (date) => {
  const monday = startOfISOWeek(date);
  const thursday = new Date(monday);
  thursday.setDate(monday.getDate() + 3);

  const weekYear = thursday.getFullYear();
  const firstMonday = startOfISOWeek(new Date(weekYear, 0, 4));
  const week = Math.round((monday - firstMonday) / 604800000) + 1;
  return `${weekYear}-W${pad(week)}`;
};

const dateFromISOWeek = (value, endBoundary) => {
  const match = /^(\d{4})-W(\d{2})$/.exec(value || '');
  if (!match) return null;

  const firstMonday = startOfISOWeek(new Date(Number(match[1]), 0, 4));
  const result = new Date(firstMonday);
  result.setDate(
    firstMonday.getDate() + (Number(match[2]) - 1) * 7 + (endBoundary ? 6 : 0)
  );
  return result;
};

const getShanghaiToday = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
    .formatToParts(new Date())
    .reduce((result, part) => {
      result[part.type] = part.value;
      return result;
    }, {});
  return new Date(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day)
  );
};

export const getDefaultDateRange = () => {
  const start = getShanghaiToday();
  start.setDate(start.getDate() - 7);
  const end = getShanghaiToday();
  end.setDate(end.getDate() - 1);
  return {
    start: toDateInput(start),
    end: toDateInput(end),
  };
};

export const periodInputMeta = (period) => {
  switch (period) {
    case 'w':
      return { type: 'week', startLabel: '开始周', endLabel: '结束周' };
    case 'm':
      return { type: 'month', startLabel: '开始月份', endLabel: '结束月份' };
    default:
      return { type: 'date', startLabel: '开始日期', endLabel: '结束日期' };
  }
};

export const toPeriodInputValue = (dateValue, period) => {
  const date = parseDateInput(dateValue);
  if (!date) return '';
  if (period === 'w') return isoWeekValue(date);
  if (period === 'm') return dateValue.slice(0, 7);
  return dateValue;
};

export const fromPeriodInputValue = (value, period, endBoundary) => {
  if (period === 'w') {
    const date = dateFromISOWeek(value, endBoundary);
    return date ? toDateInput(date) : '';
  }
  if (period === 'm') {
    const match = /^(\d{4})-(\d{2})$/.exec(value || '');
    if (!match) return '';
    const year = Number(match[1]);
    const month = Number(match[2]);
    const date = endBoundary
      ? new Date(year, month, 0)
      : new Date(year, month - 1, 1);
    return toDateInput(date);
  }
  return parseDateInput(value) ? value : '';
};

export const normalizeDateRangeForPeriod = (startValue, endValue, period) => ({
  start: fromPeriodInputValue(
    toPeriodInputValue(startValue, period),
    period,
    false
  ),
  end: fromPeriodInputValue(toPeriodInputValue(endValue, period), period, true),
});

export const toBoundaryTimestamp = (dateValue, endBoundary) => {
  if (!parseDateInput(dateValue)) return null;
  const time = endBoundary ? '23:59:59' : '00:00:00';
  return Math.floor(Date.parse(`${dateValue}T${time}+08:00`) / 1000);
};
